export const launchTypes = {
    LAUNCHTYPE_REGULAR: 0,
    LAUNCHTYPE_NEWWINDOW: 1,
    LAUNCHTYPE_NEWCHROMELESSWINDOW: 2,
};

